
import { Link } from 'react-router-dom';
import StudyOption from '../AllData/HomeData';
import './style/Home.css';
import TopNavbar from './TopNavbar';
import { useEffect, useState } from 'react';
import useUsersData from '../Auth/AllUsers';
import UsePayments from '../Backend/UsePayments';
import UsePaymentItems from '../Backend/UsePaymentItems';
import PaidItems from "../AllData/PaidItems";
import { OnlineStatus } from '../Component/OnlineStatus';
import { ItemClick } from '../Component/ItemClick';
import { useTrackUser } from '../Component/useTrackUser';
import { usePreventBackButton } from '../Component/usePreventBackButton';
import { PaymentBadge } from '../Component/PaymentBadge';
import OfferTime from '../Component/OfferTime';



function Home() {
  const studyOptions = StudyOption;
  const activeOptions = studyOptions.filter(option => option.status === "true");
  const { users, loading } = useUsersData();
  const [paymentStatus, setPaymentStatus] = useState(false);
  const { allPayments, paymentLoading } = UsePayments();
  const { paymentItems } = UsePaymentItems();

  const userPhone = localStorage.getItem('userPhone');

  const isOnline = OnlineStatus();


  const targetUser = users.find(user => user.phone === userPhone);
  const userName = targetUser?.name;
  const userEmail = targetUser?.email;
  const userClass = targetUser?.class;
  const registerDate = targetUser?.registar_date;
  const lastLogin = targetUser?.last_login;

  useEffect(() => {
    const hasPayment = allPayments.some(payment => payment.phone === userPhone);
    if (isOnline) { setPaymentStatus(hasPayment) };
  }, [allPayments, userPhone]);

  if (isOnline) {

    const targetPayment = allPayments.find(payment => payment.phone === userPhone);
    const buyItem = targetPayment?.buyed;
    const itemPrice = targetPayment?.amount;
    const targetPaymentItem = paymentItems.find(paymentItem => paymentItem.itemId == buyItem);
    const itemName = targetPaymentItem?.name;
    const itemAbout = targetPaymentItem?.about;
    const itemValid = targetPaymentItem?.valid;
    const itemYear = targetPaymentItem?.year;

    if (userPhone && !loading && !paymentLoading) {
      localStorage.setItem('userPhone', userPhone);
      localStorage.setItem('userEmail', userEmail);
      localStorage.setItem('userName', userName);
      localStorage.setItem('userClass', userClass);
      localStorage.setItem('registerDate', registerDate);
      localStorage.setItem('lastLogin', lastLogin);

      if (paymentStatus) {
        localStorage.setItem('userPayment', userPhone);
        localStorage.setItem('itemName', itemName);
        localStorage.setItem('itemPrice', itemPrice);
        localStorage.setItem('itemAbout', itemAbout);
        localStorage.setItem('itemValid', itemValid);
        localStorage.setItem('itemYear', itemYear);
      } else {
        localStorage.setItem('userPayment', '');
      }
    }
  }

  const userPayment = localStorage.getItem('userPayment');
  const currentUserId = localStorage.getItem('userId');
  const name = userName || "to NEET Prep App";

  usePreventBackButton();
  useTrackUser();

  return (
    <div className="study-app">

      <TopNavbar name={name} />

      <header className="app-header">
        <h2 style={{ color: "green" }}>🎯 NEET UG → 🩺 MBBS</h2>
        {!userPayment && <p><strong>🎉 One Subscription. Everything Unlocked!</strong></p>}
        {!isOnline && <p style={{ color: 'red', fontSize: '12px' }}>You are offline.</p>}
       
      </header>

      {!userPayment && <OfferTime />}

     


      <div className="study-grid">

        {activeOptions.map(option => {

          const isPaid = PaidItems.includes(option.id);

          return (
            <Link
              to={option.link}
              key={option.id}
              className="study-card-link"
              onClick={(userPhone === '9999999991' || userPhone === '9999999992') ? undefined : () => ItemClick(option, userPhone, currentUserId)}
            >
              <div className="study-card" style={{ position: 'relative' }}>

                <PaymentBadge userPayment={userPayment} optionId={option.id} isPaid={isPaid} />

                <div className="card-icon">
                  <span style={{ fontSize: '70px' }}>{option.symbol}</span>
                </div>
                <h3>{option.name}</h3>

              </div>
            </Link>
          );
        })}
      </div>

    </div>
  );
}


export default Home;